var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContrae(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e8d2849f58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c5667e90a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 207 73 L 302 73 L 302 167 L 207 167 Z M 207 73 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdedc8a35c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 321.964844 96.246094 L 230.75 187.460938 L 187.261719 143.976562 L 278.480469 52.757812 Z M 321.964844 96.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a741905ff9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 321.964844 96.246094 L 230.75 187.460938 L 187.261719 143.976562 L 278.480469 52.757812 Z M 321.964844 96.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5abbc4529e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73 208 L 168 208 L 168 302 L 73 302 Z M 73 208 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad2270591e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.023438 278.746094 L 144.238281 187.527344 L 187.726562 231.015625 L 96.511719 322.230469 Z M 53.023438 278.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e58a80f41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.023438 278.746094 L 144.238281 187.527344 L 187.726562 231.015625 L 96.511719 322.230469 Z M 53.023438 278.746094 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e8d2849f58)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 0.0000045, 0)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 249.999994 0 C 111.927078 0 -0.000006 111.927084 -0.000006 250 C -0.000006 388.072917 111.927078 500.000001 249.999994 500.000001 C 388.072911 500.000001 499.999995 388.072917 499.999995 250 C 499.999995 111.927084 388.072911 0 249.999994 0 ",
    stroke: "#c7d300",
    strokeWidth: 8,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c5667e90a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bdedc8a35c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a741905ff9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7d300",
    d: "M 207.828125 126.003906 L 207.941406 162.15625 C 207.949219 164.664062 210.019531 166.730469 212.527344 166.742188 L 248.71875 166.894531 C 251.226562 166.90625 253.28125 164.847656 253.273438 162.339844 C 253.265625 159.835938 251.195312 157.765625 248.6875 157.757812 L 223.535156 157.675781 L 300.242188 80.972656 C 302.015625 79.199219 302.007812 76.285156 300.222656 74.5 C 298.4375 72.714844 295.527344 72.707031 293.753906 74.480469 L 217.085938 151.144531 L 217.007812 125.996094 C 217.003906 124.699219 216.472656 123.605469 215.621094 122.753906 C 214.769531 121.902344 213.636719 121.414062 212.382812 121.371094 C 209.875 121.441406 207.820312 123.5 207.828125 126.003906 Z M 207.828125 126.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5abbc4529e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad2270591e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e58a80f41)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7d300",
    d: "M 167.160156 248.984375 L 167.046875 212.832031 C 167.039062 210.324219 164.96875 208.257812 162.460938 208.25 L 126.269531 208.09375 C 123.761719 208.085938 121.707031 210.140625 121.714844 212.648438 C 121.722656 215.15625 123.792969 217.222656 126.300781 217.230469 L 151.453125 217.3125 L 74.746094 294.019531 C 72.972656 295.792969 72.980469 298.703125 74.765625 300.488281 C 76.550781 302.273438 79.460938 302.28125 81.234375 300.507812 L 157.902344 223.84375 L 157.980469 248.996094 C 157.984375 250.289062 158.515625 251.382812 159.367188 252.234375 C 160.21875 253.085938 161.351562 253.574219 162.605469 253.621094 C 165.113281 253.546875 167.167969 251.492188 167.160156 248.984375 Z M 167.160156 248.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrae);
export default __webpack_public_path__ + "static/media/contrae.19d6096113e34f215a78357cf278d675.svg";
export { ForwardRef as ReactComponent };